/**
 * Created by JIocb on 26.05.2017.
 */

namespace Factive.Game {
    import Signal = Factive.Core.Signal.Signal;
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import List = Factive.Core.Linq.List;
    import ISoundManager = Factive.Core.ISoundManager;

    export class DiceRollingBox extends PIXI.Container {

        public signal: Signal;
        private _box: DiceRendererClass;
        private _dc: DependenciesContainer;
        private _buttons: Array<PIXI.Sprite> = [];
        private _layers: Array<PIXI.Container> = [];
        private _boxResult: Array<DiceResultInterface> = [];
        private _dicesDataResult: Array<DiceData> = [];
        private _isResting: boolean = true;
        private _assetScale:number = 1;
        private _aspectRatio: string = null;
        private _userBagModel: Factive.Game.UserBagModel;
        private sprite_3D: Factive.Game.Pixi3DSprite;

        constructor(dc, aspectRatio, userBagModel: Factive.Game.UserBagModel) {
            super();
            this._userBagModel = userBagModel;
            this._aspectRatio = aspectRatio;
            this._assetScale = dc.get("AssetScale");
            this._dc = dc;
            this.signal = new Signal();

            this.build();
        }

        private build() {
            this._layers[0] = new PIXI.Container();
            this.addChild(this._layers[0]);

            this._layers[1] = new PIXI.Container();
            this.addChild(this._layers[1]);

            this._box = this._dc.get("DiceRenderer");
            this.sprite_3D = new Pixi3DSprite(this._box, this._assetScale);
            this._layers[1].addChild(this.sprite_3D);


            for (let i = 0; i < 5; i++) {
                let btn = new PIXI.Sprite(Resources.getTextureData("cercle_white").texture);
                this._layers[1].addChild(btn);
                this._buttons[i] = btn;
                btn.alpha = 0; // only for test show position dice button
                btn.tint = 0x000000;

                btn.hitArea = new PIXI.Circle(0, 0, 30*this._assetScale);
                btn.interactive = false;
                btn.buttonMode = false;
                btn.on("pointerup", this.handleDiceSelect, this);
                btn.on("pointerover", this.handleDiceOver, this);
                btn.on("pointerout", this.handleDiceOut, this);
            }

        }


        public get isResting(): boolean
        {
            return this._isResting;
        }

        private internalRoll( isBonus: boolean = false, bag:Array<DiceData> = null): void {

            this._boxResult = [];
            this._dicesDataResult = [];
            this._isResting = false;

            for (let i: number = 0; i < this._buttons.length; i++) {
                let btn = this._buttons[i];
                btn.interactive = false;
                btn.buttonMode = false;
            }

            this._box.clear();

            let sm:ISoundManager = <ISoundManager>this._dc.get("SoundManager");
            sm.playSound(SoundConstants.DICE);

            if (isBonus) {
                this._box.startBonusThrow(this.handleRollComplete, this);
            }
            else {
                this._box.startRegularThrow(bag, this.handleRollComplete, this);
            }

        }

        public bonusRoll(): void {
            this.internalRoll(true);
        }

        public regularRoll(): void {

            this.internalRoll(false,this._userBagModel.getDices());
        };

        protected handleRollComplete(box_result:Array<DiceResultInterface>): void {
            this._boxResult = box_result;
            this._dicesDataResult = [];

            // for test same color
            // for (let i = 0; i < box_result.length; i++) {
            //     box_result[i].color = 1;
            // }
            // box_result[4].value = 6;
            //3,5,4,1,2
            // box_result[0].value = 2;
            // box_result[1].value = 3;
            // box_result[2].value = 4;
            // box_result[3].value = 5;
            // box_result[4].value = 2;

            // let boxResultList = new List<DiceResultInterface>(box_result);
            // let resultColors = boxResultList.Select(o => o.color).ToArray();
            // let resultValues = boxResultList.Select(o => o.value).ToArray()
            //
            // console.log("colors", resultColors.join(","));
            // console.log("values", resultValues.join(","));

            for (let i = 0; i < box_result.length; i++) {

                let resItem = box_result[i];
                let dice = new DiceData();
                dice.initialize(resItem.color, resItem.value);
                dice.id = resItem.user_id;
                this._dicesDataResult[i] = dice;

                let btn: PIXI.Sprite = this._buttons[i];
                //btn.alpha = 0; // for test

                dice.btn = this._buttons[i];
                btn.interactive = false;
                btn.buttonMode = false;

                if(resItem.isBonus != true)
                {
                    let pos =  this._box.getDicePositionById(dice.id);
                    btn.x = pos.x * 24 * this._assetScale;//* .52;
                    btn.y = -pos.y *24 * this._assetScale;//* .52;
                    btn.anchor.set(.5, .5);

                    if(this.ifExistInBag(dice) == false)
                    {
                        btn.interactive = true;
                        btn.buttonMode = true;
                    }

                    btn["dice_id"] = resItem.user_id;
                }

                if(resItem.isBonus == true)
                {
                    this.sendEvent(DiceRollingBoxEventType.COLOR_BONUS, {dice: resItem});
                }
            }

            this._isResting = true;
            this.sendEvent(DiceRollingBoxEventType.ROLL_COMPLETE, {result: this._dicesDataResult});
        }

        private ifExistInBag(diceData:DiceData)
        {
            let bag:Array<DiceData> = this._userBagModel.getDices();
            if(bag)
            {
                let l: number = bag.length;
                for(let i:number = 0; i<l; i++)
                {
                    if(bag[i].id == diceData.id) {
                        bag[i].btn = diceData.btn;
                        return true;
                    }
                }
            }
            return false;
        }

        public handleDiceSelect(evt) {
            let dice_id = evt.currentTarget["dice_id"];

            this._box.hideDiceByUserId(dice_id);

            let btn = evt.currentTarget;
            btn.interactive = false;
            btn.buttonMode = false;

            for(let i = 0; i< this._dicesDataResult.length; i++){
                if(this._dicesDataResult[i].id == dice_id){
                    this.sendEvent(DiceRollingBoxEventType.DICE_SELECTED, {
                        id: dice_id,
                        dice: this._dicesDataResult[i]
                    });
                    return;
                }
            }


        }

        public handleDiceOver(evt) {
            let dice_id = evt.currentTarget["dice_id"];
            this._box.colorizeDice(dice_id, 0xFFEFA8);
        }

        public handleDiceOut(evt) {
            let dice_id = evt.currentTarget["dice_id"];
            this._box.colorizeDice(dice_id, 0xFfFfFf);
        }

        public hideDicesExceptIds(ids: Array<number>) {
            //console.log("hideDicesExceptIds");

            let dct: Array<any> = [];
            if(ids!=null && ids !=undefined) {
                let l: number = ids.length;
                for (let i: number = 0; i < l; i++) {
                    dct[ids[i]] = true;
                }
            }

            let l = this._dicesDataResult.length;
            for (let i = 0; i < l; i++) {
                let id: number = this._dicesDataResult[i].id;


                let btn = this._buttons[i];
                btn.interactive = false;
                btn.buttonMode = false;

                if (dct[id] != true) {
                    this._box.hideDiceByUserId(id)
                }
            }

        };

        public showDicesExceptIds(ids: Array<number>) {
            let dct: Array<any> = [];
            var l: number = ids.length;
            for (let i: number = 0; i < l; i++) {
                dct[ids[i]] = true;
            }

            l = this._dicesDataResult.length;
            for (let i = 0; i < l; i++)
            {
                let resItem = this._boxResult[i];
                let dice: DiceData = this._dicesDataResult[i];

                if (dct[dice.id] != true)
                {
                    this._box.showDice(dice.id, dice.value, dice.color);

                    let btn: PIXI.Sprite = this._buttons[i];

                    let pos =  this._box.getDicePositionById(dice.id);
                    btn.x = pos.x * 24 * this._assetScale;
                    btn.y = -pos.y * 24 * this._assetScale;

                    btn.anchor.set(.5, .5);

                    btn["dice_id"] = resItem.user_id;
                    btn.interactive = true;
                    btn.buttonMode = true;

                }
            }

        };

        public showDice(dice: DiceData) {
            this._box.showDice(dice.id,dice.value,dice.color);

            let btn = dice.btn;
            let pos =  this._box.getDicePositionById(dice.id);
            btn.x = pos.x * 24 * this._assetScale;
            btn.y = -pos.y * 24 * this._assetScale;

            btn.interactive = true;
            btn.buttonMode = true;

        }

        private sendEvent(type: number, data?: any) {
            this.signal.dispatch(type, data);
        }

        public destroy():void
        {
            this.signal.removeAll();
            this.signal = null;
            this._box.destroy();
            this._dc = null;
            this.removeChildren();
            this._layers = null;
            for (let i: number = 0; i < this._buttons.length; i++) {
                let btn = this._buttons[i];
                btn.off("pointerup", this.handleDiceSelect, this);
                btn.off("pointerover", this.handleDiceOver, this);
                btn.off("pointerout", this.handleDiceOut, this);
                btn.interactive = false;
                btn.buttonMode = false;
            }
            this._boxResult = null;
            this._dicesDataResult = null;

            super.destroy();
        }

        public applyAspectRatio(aspectRatio: string)
        {
            this._aspectRatio = aspectRatio;
            this._box.applyAspectRatio(this._aspectRatio);

            this.buttonsPositioningBaseOnAspectRatio(aspectRatio);
            if(this._aspectRatio == "landscape")
            {
                this.scale.x = this.scale.y = 1;
            }
            else if(this._aspectRatio == "portrait")
            {
                this.scale.x = this.scale.y = 1.2;
            }


            if(this._aspectRatio == "landscape")
            {
                this.sprite_3D.y = 40 * this._assetScale;
            }
            else if(this._aspectRatio == "portrait")
            {
                this.sprite_3D.y = -80 * this._assetScale;
            }
        }

        private buttonsPositioningBaseOnAspectRatio(aspectRatio:string):void
        {
            let l:number=  this._boxResult.length;
            for(let i:number = 0; i<l; i++)
            {
                let btn: PIXI.Sprite = this._buttons[i];

                let pos =  this._box.getDicePositionById(btn["dice_id"]);
                btn.x = pos.x * 24 * this._assetScale;
                btn.y = -pos.y * 24 * this._assetScale;

                btn.anchor.set(.5, .5);
            }
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/View/DiceRollingBox.ts